/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { demandStatusSchema } from './demandStatusSchema';

export const demandStatusListSchema = z.object({
  get data() {
    return z.array(demandStatusSchema);
  },
});
